import type { IServiceProtocol } from '@/service/vpc/types/IServiceProtocol';
import type { IUnit } from '@/service/vpc/types/IUnit';
import type { TFunction } from 'i18next';

import { chassis } from '@/utils';

export const getServiceProtocolChassisPosition = (
  unit: IUnit | undefined,
  spa: IServiceProtocol,
  t: TFunction<'translation', undefined>
) => {
  if (spa.serviceProtocolContentDetails?.fileName) {
    return t(($) => $.pages.unit.maintenance.download_pdf);
  }

  if (!unit) {
    return 'Not applicable';
  }

  const chassisSeries = spa.chassisSeries;
  const chassisNumber = String(spa.chassisNumber);
  const chassisId = chassis.getId({ chassisSeries, chassisNumber });

  const positionName = chassis.getDrivelinePosition(unit, chassisId).positionName;

  return positionName ? `${positionName}` : '';
};

export const generateServiceTitle = (spa: IServiceProtocol, t: TFunction<'translation', undefined>): string => {
  if (spa.serviceProtocolContentDetails?.fileName) {
    return spa.customProtocolName;
  }

  return t(($) => $.pages.unit.maintenance.default_service, {
    chassisSeries: `${spa.chassisSeries.toUpperCase()}`,
    chassisNumber: spa.chassisNumber,
  });
};

export const getType = (serviceDescription: string) => {
  const serviceTypePrefix = /(?=.{0,2}$)^[A-Z][0-9]?(?![A-Z])/;
  const serviceType = serviceDescription.split(' ')[0];
  if (!serviceTypePrefix.test(serviceType)) {
    return undefined;
  }
  return serviceType;
};
